import banner from "@/store/banner";
import Vuex from "vuex";
import { i18n, setI18nLanguage } from "@/i18n";
import VeeValidate, { Validator } from "vee-validate";
import validatorEs from "@/validator/es";
import validatorEn from "@/validator/en";
import axios from "axios";

const store = new Vuex.Store({
  state: {
    language: null,
    server: "https://back.ajusa.es/",
    likes: JSON.parse(localStorage.getItem("likes")) || new Array(),
    hints: JSON.parse(localStorage.getItem("hints")) || new Array(),
    validators: {
      es: validatorEs,
      en: validatorEn
    },
    videos: null,
    popup: true,
    tips: [],
    currentTips: [],
    categories: []
  },
  getters: {
    getLanguage: state => state.language,
    getPopup: state => state.popup,
    getServer: state => state.server,
    getlike(state) {
      return slug => {
        return state.likes.some(l => l == slug);
      };
    },
    gethint(state) {
      return slug => {
        return state.hints.some(l => l == slug);
      };
    },
    getVideos(state) {
      return state.videos;
    },
    getTips: state => state.tips
  },
  actions: {
    changeLanguage: ({ commit, state }, changeTo) => {
      return new Promise((resolve, reject) => {
        commit("setLanguage", changeTo);
        setI18nLanguage(changeTo);
        Validator.localize(
          "es",
          state.validators[changeTo]
            ? state.validators[changeTo]
            : state.validators["en"]
        );
        document.documentElement.setAttribute("lang", i18n.t("isotag"));

        resolve(changeTo);
      });
    },
    sendLike: ({ commit }, slug) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`like/${slug}`)
          .then(response => {
            resolve(response.data.likes);
            commit("addLike", slug);
          })
          .catch(function(error) {
            reject(false);
          });
      });
    },
    sendHint: ({ commit }, slug) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`hint/${slug}`)
          .then(response => {
            resolve(response.data.hints);
            commit("addHint", slug);
          })
          .catch(function(error) {
            reject(false);
          });
      });
    },
    setVideos({ commit }, url) {
      if (this.state.videos) {
        return;
      }

      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(result => {
            resolve(result.data.items);
            commit("addVideos", result.data.items);
          })
          .catch(e => {
            commit("addVideos", [
              {
                kind: "youtube#searchResult",
                etag: "q0k6t9beyghWUZ7QAvWFG6-nE4I",
                id: { kind: "youtube#video", videoId: "68ybyBPz1uk" },
                snippet: {
                  publishedAt: "2025-03-28T18:00:04Z",
                  channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                  title:
                    "Componentes Ajusa para motor eléctrico | Tesla Model 3",
                  description:
                    "(es) En Ajusa, apostamos por la ingeniería del hoy y del mañana. Así luce el motor eléctrico de un Tesla Model 3, desglosado ...",
                  thumbnails: {
                    default: {
                      url: "https://i.ytimg.com/vi/68ybyBPz1uk/default.jpg",
                      width: 120,
                      height: 90
                    },
                    medium: {
                      url: "https://i.ytimg.com/vi/68ybyBPz1uk/mqdefault.jpg",
                      width: 320,
                      height: 180
                    },
                    high: {
                      url: "https://i.ytimg.com/vi/68ybyBPz1uk/hqdefault.jpg",
                      width: 480,
                      height: 360
                    }
                  },
                  channelTitle: "Ajusa",
                  liveBroadcastContent: "none",
                  publishTime: "2025-03-28T18:00:04Z"
                }
              },
              {
                kind: "youtube#searchResult",
                etag: "mbacmEcJEN0GnbiawRPtay-2Wg8",
                id: { kind: "youtube#video", videoId: "kzfE9VtY5YE" },
                snippet: {
                  publishedAt: "2025-03-20T19:30:08Z",
                  channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                  title:
                    "Soluciones #Ajusa para las averías más comunes en #MotoresEléctricos!",
                  description:
                    "Primeros kits del mercado para reparar las averías más comunes de los #motoreseléctricos: ✓ Fallo de aislamiento por ...",
                  thumbnails: {
                    default: {
                      url: "https://i.ytimg.com/vi/kzfE9VtY5YE/default.jpg",
                      width: 120,
                      height: 90
                    },
                    medium: {
                      url: "https://i.ytimg.com/vi/kzfE9VtY5YE/mqdefault.jpg",
                      width: 320,
                      height: 180
                    },
                    high: {
                      url: "https://i.ytimg.com/vi/kzfE9VtY5YE/hqdefault.jpg",
                      width: 480,
                      height: 360
                    }
                  },
                  channelTitle: "Ajusa",
                  liveBroadcastContent: "none",
                  publishTime: "2025-03-20T19:30:08Z"
                }
              },
              {
                kind: "youtube#searchResult",
                etag: "Xokdq7OeMGJzWZ5jJCY6mAqES3Y",
                id: { kind: "youtube#video", videoId: "yM09Spy63pI" },
                snippet: {
                  publishedAt: "2025-03-10T19:00:51Z",
                  channelId: "UCnoYVeFbsPiOVOcf80tW6Bg",
                  title:
                    "¿Cómo funciona el turbo y su sistema de lubricación? ¡En 3D!🤯",
                  description:
                    "(es) ¿Cómo funciona el turbo y su sistema de lubricación? ¿Cuáles son las diferentes partes de un turbo? Ajusa te lo enseña.",
                  thumbnails: {
                    default: {
                      url: "https://i.ytimg.com/vi/yM09Spy63pI/default.jpg",
                      width: 120,
                      height: 90
                    },
                    medium: {
                      url: "https://i.ytimg.com/vi/yM09Spy63pI/mqdefault.jpg",
                      width: 320,
                      height: 180
                    },
                    high: {
                      url: "https://i.ytimg.com/vi/yM09Spy63pI/hqdefault.jpg",
                      width: 480,
                      height: 360
                    }
                  },
                  channelTitle: "Ajusa",
                  liveBroadcastContent: "none",
                  publishTime: "2025-03-10T19:00:51Z"
                }
              }
            ]);
            reject(e);
          });
      });
    },
    changePopup({ state }, status) {
      state.popup = status;
    },
    fetchTips({ commit, state }, lang) {
      return new Promise((resolve, reject) => {
        axios
          .get(`tips-new?lang=${lang}`)
          .then(response => {
            commit("setTips", response.data.tips);
            const weekBefore = new Date();
            weekBefore.setDate(new Date().getDate() - 7);
            const tips = response.data.tips.filter(tip => {
              return new Date(tip.creado).getTime() > weekBefore.getTime();
            });
            state.currentTips = tips;
            state.categories = response.data.categories;
            resolve(response.data.tips);
          })
          .catch(error => console.log(error));
      });
    }
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
    },
    addLike(state, slug) {
      state.likes.push(slug);
      window.localStorage.setItem("likes", JSON.stringify(state.likes));
    },
    addHint(state, slug) {
      state.hints.push(slug);
      window.localStorage.setItem("hints", JSON.stringify(state.hints));
    },
    addVideos(state, videos) {
      state.videos = videos;
    },
    setTips(state, tips) {
      state.tips = tips;
    }
  },
  modules: {
    banner
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js